export const normalizePhone = (phone) => {
    return parseInt(phone?.replace(/[^0-9]/g, ''));
    // `int` is now 73443433443. 
}